import { isInIframe, getQueryString } from '@umu/umu-dom';

const isIframe = isInIframe();

// 父frame是否是课程
export const isParentLocationCourse = (parenInfo: { origin: string; pathname: string; href: string }): boolean => {
    const courseReg = /course/;
    const originReg = /umu./;
    if (isIframe) {
        if (parenInfo?.href) {
            const { origin, pathname } = parenInfo;
            return courseReg.test(pathname) && originReg.test(origin) && isIframe;
        } else {
            return true;
        }
    } else {
        return false;
    }
};

export const isParentLocationProgram = (parenLocalInfo?: {
    origin: string;
    pathname: string;
    href: string;
}): boolean => {
    if (!isIframe) {
        return false;
    }
    if (!parenLocalInfo?.href) {
        return getQueryString('parent') === 'program';
    }
    const reg = /program/;
    const originReg = /umu./;
    const { origin, pathname } = parenLocalInfo;
    return reg.test(pathname) && originReg.test(origin);
};

// url上明确带参数
export const isLandscapeByUrlQuery = (): boolean => {
    const isLandScapeQuery = /pc_landscape/.test(location.href);
    const isMobileSite = /m\..*umu/.test(location.origin);
    return isLandScapeQuery && isMobileSite;
};
